<script>
    import { getContext } from 'svelte';

    export let modalKey = 'simple-modal';
    export let errorMessage = null;

    const { close } = getContext(modalKey);


    console.log("Error Message", errorMessage);
</script>

<h1>Error</h1>
<p>Errors have been found</p>

{errorMessage.message}
